import { ReactNode } from 'react';
import { FunnelImage } from 'core/flow/entities';
import { Button } from '../../Button';
import { Image } from '../../Image';

type ButtonOptionProps = {
  image?: FunnelImage;
  onClick: () => void;
  children?: ReactNode;
};

export const ButtonOption = ({ onClick, children, image, ...otherProps }: ButtonOptionProps) => {
  const Icon = image && <Image alt={image.alt} src={image.src as string} width={20} height={20} />;

  return (
    <Button
      fullWidth
      gutterBottom
      onClick={onClick}
      variant="option"
      startIcon={Icon}
      {...otherProps}
    >
      {children}
    </Button>
  );
};
